const KEY = 'cs_signup_pending_email';

/**
 * The address a verification email went to, kept for this tab only so the code screen
 * survives a reload (in-app browsers reload after a switch to the mail app) without
 * putting the address in the URL.
 */
export function setPendingSignupEmail(email: string | null) {
  try {
    if (email) sessionStorage.setItem(KEY, email);
    else sessionStorage.removeItem(KEY);
  } catch {
    // Private mode or blocked storage: the code screen still works until a reload.
  }
}

export function getPendingSignupEmail(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}
